import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {SafeResourceUrl} from '@angular/platform-browser';
import {Table} from 'primeng/table';
import {SelectItem} from 'primeng/api';
import {NavService} from '../../../../_services/_nav.service';
import {Variable} from '../../../../_models/variable-sarlaft';
import {AppSettings} from "../../../../../proyect.conf";
import {AutenticacionService} from "../../../../_services/autenticacion.service";
import {SarlaftCondicionesService} from '../../../../_services/sarlaft-condiciones.service';
import {Constantes, TipoOpcion} from '../../../../_enums/enum';
import {ConfirmationService} from "primeng/api";
import {obteneItemSarlaft, obteneItemTablaSarlaft} from '../../../../utils/utilidades';
import {DivisionPoliticaService} from '../../../../_services/division-politica.service';
import {DivisionPolitica} from '../../../../_models/division-politica';
import {AdjuntoService} from '../../../../_services/adjunto.service';
import {ConstanteService} from "../../../../_services/constante.service";

@Component({
  selector: 'app-sarlaft-variables-condiciones',
  templateUrl: './sarlaft-variables-condiciones.component.html',
  styleUrls: ['./sarlaft-variables-condiciones.component.css']
})
export class SarlaftVariablesCondicionesComponent implements OnInit {

  rutaAdjunto = AppSettings.rutServiciosSarlaft + '/api/riesgosSarlaftVariablesAdjuntosCargue/validarRegistrosAdjunto/riesgoSarlaftVariable/';
  @Input() variable: Variable;
  @Input() verDetalle: boolean;
  @ViewChild('dt') tabla: Table;
  formulario: FormGroup;
  imagen: SafeResourceUrl;
  listaVariables: Variable[] = [];
  cargaCondiciones = true;
  estadoEditar: boolean = false;
  submitted: boolean = false;
  busqueda: string;
  columnas: any[];
  condicion: any;
  lisgenerica: SelectItem[] = [];
  fsize!: number;
  ftype = '';
  nombreArchivo: string = '';
  nombreCargueArchivo: string = '';
  modalAbierto = false;
  modal = {width: '400px'};
  estado = 'car';
  mensajes: string[] = [];
  idRiesgoSarlaftVariable = '';
  fechaCargueArchivo: string;
  tipOpcion = TipoOpcion;
  nombreGenerico: String;
  respuesta: any;
  lisGenericaTodos: any[] = [];
  lista: any[] = [];
  valorEvento: any;
  listaSecundaria: DivisionPolitica[] = [];
  listaVariablesColumnasFinalesIguales: any = [];
  listaboolean: SelectItem[] = [{label: 'SI', value: true}, {label: 'NO', value: false}];
  codExiste = false;
  listaVariablesCondicionesInformacionFinanciera: any = [];
  public segundoInputHabilitado: boolean = false;
  listaDepartamentos: any = [];
  loading: boolean = false;
  rangoIncialValido: boolean = true;
  disabledLista : boolean = false;
  constructor(  private navServicio: NavService,
                private fb: FormBuilder,
                private autServicio: AutenticacionService,
                private sarlaftCondicionesService: SarlaftCondicionesService,
                private confirmacionServicio: ConfirmationService,
                private divisionPoliticaService: DivisionPoliticaService,
                private adjService: AdjuntoService,
                private constanteService: ConstanteService) { }

  ngOnInit(): void {
    this.loading = true;
    this.listaVariablesColumnasFinalesIguales = [TipoOpcion.NACION, TipoOpcion.JURISD, TipoOpcion.INFIPA, TipoOpcion.OCUPAC, TipoOpcion.PRODUC, TipoOpcion.TIPOCU,
      TipoOpcion.NINGUNO, TipoOpcion.INFIIN, TipoOpcion.INFIEG, TipoOpcion.INFIAC, TipoOpcion.INFIPT, TipoOpcion.ACTECO, TipoOpcion.PEP, TipoOpcion.VCANAL];
    this.listaVariablesCondicionesInformacionFinanciera = [TipoOpcion.INFIIN, TipoOpcion.INFIEG, TipoOpcion.INFIAC, TipoOpcion.INFIPT, TipoOpcion.INFIPA];
    this.cargaInicial();
    this.limpiarBuscador()
  }

  cargaInicial() {
    this.asignarColumnas();
    this.condicion = [];
    this.lista = [];
    this.listaDepartamentos = [];
    this.lisGenericaTodos = [];
    this.lisgenerica = [];
    this.codExiste = null;
    this.busqueda = this.navServicio.getSearch( 'sarlaftCondiciones.component' );
    this.constanteService.getByCode(Constantes.FSIZE).subscribe(x => this.fsize = Number(x.valor));
    this.cargarFormulario();
    if (this.variable && this.variable.idRiesgoSarlaftVariable) {
      this.rutaAdjunto += this.variable.idRiesgoSarlaftVariable;
      this.sarlaftCondicionesService.obtenerCargueAdjunto(this.variable.idRiesgoSarlaftVariable).subscribe( res => {
        if(res){
          this.fechaCargueArchivo = res.auditoriaFecha;
          this.nombreCargueArchivo = res.nombreArchivo;
        }
      });
    }
    const opcion = this.buscarValorEnEnum(this.variable.codigoVariableSarlaft);
    this.nombreGenerico = this.setNombreGenerico(this.variable.codigoVariableSarlaft);

    this.sarlaftCondicionesService.ejecutarServicios( opcion, this.variable ).subscribe(
      (response) => {
        this.condicion = obteneItemTablaSarlaft( opcion, response[0]);
        this.lista = response[1];
        this.asignarValoresLista();
      },
      (error: any) => {
        this.loading = false;
        this.cerrarFondoGlobalModal();
        console.error('Error al ejecutar servicios:', error);
      }
    );
    if (this.variable.codigoVariableSarlaft === this.tipOpcion.PEP) {
      this.f.valor.setValidators([Validators.required]);
    }
    this.submitted = false;
  }

  asignarValoresLista() {
    switch (this.variable.codigoVariableSarlaft) {
      case TipoOpcion.NACION:
        const listaDivisionPolitica = new Set(this.condicion.map(item => item.codigoDivisionPolitica));
        this.lisGenericaTodos = this.lista.filter(item => !listaDivisionPolitica.has(item.codigoDivisionPolitica));
        break;
      case TipoOpcion.JURISD:
        this.lisGenericaTodos = this.lista;
        break;
      case TipoOpcion.VCANAL:
        const lisCanal = new Set(this.condicion.map(item => item.canal));
        this.lisGenericaTodos = this.lista.filter(item => !lisCanal.has(item.nombre));
        break;
      case TipoOpcion.TIPOCU:
        const lisTipoOcupa = new Set(this.condicion.map(item => item.codigoTipoOcupacion));
        this.lisGenericaTodos = this.lista.filter(item => !lisTipoOcupa.has(item.codigo));
        break;
      case TipoOpcion.PRODUC:
        const lisTipoProduc = new Set(this.condicion.map(item => item.codigoProducto));
        this.lisGenericaTodos = this.lista.filter(item => !lisTipoProduc.has(item.codigo));
        break;
      case TipoOpcion.OCUPAC:
        const lisOcupa = new Set(this.condicion.map(item => item.codigoOcupacion));
        this.lisGenericaTodos = this.lista.filter(item => !lisOcupa.has(item.codigoOcupacion));
        break;
      case TipoOpcion.ACTECO:
        this.lista.forEach(l => {
          const existeItem = this.condicion.find(x => x.idActividadEconomica === l.idActividadEconomica);
          if (!existeItem && l.idActividadEconomica && l.actividadEconomica) {
            this.lisGenericaTodos.push(l);
          }
        });
        break;
      default:
        this.lisGenericaTodos = this.lista;
        break;
    }
    this.obtenerListaGenerica(this.variable.codigoVariableSarlaft, this.lisGenericaTodos);
  }

  asignarColumnas() {
    this.columnas = [];
    const columnasXvariable = [];
    switch (this.variable.codigoVariableSarlaft) {
      case TipoOpcion.NACION:
        columnasXvariable.push(
          { field: 'codigoDivisionPolitica', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_CODIGO' ), sort: false },
          { field: 'descripcionDivisionPolitica', header: this.variable.variableSarlaft, sort: true }
        );
        break;
      case TipoOpcion.JURISD:
        columnasXvariable.push(
          { field: 'codigoDivisionPolitica', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_CODIGO' ), sort: false },
          { field: 'descripcionDivisionPolitica', header: this.variable.variableSarlaft, sort: true }
        );
        break;
      case TipoOpcion.NINGUNO:
        columnasXvariable.push(
          { field: 'codigo', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_CODIGO' ), sort: false },
          { field: 'tipo', header: this.variable.variableSarlaft, sort: true }
        );
        break;
      case TipoOpcion.ACTECO:
        columnasXvariable.push(
          { field: 'codigoActividadEconomica', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_CODIGO' ), sort: false },
          { field: 'actividadEconomica', header: this.variable.variableSarlaft, sort: true }
        );
        break;
      case TipoOpcion.VCANAL:
        columnasXvariable.push(
          { field: 'codigoCanal', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_CODIGO' ), sort: false },
          { field: 'canal', header: this.variable.variableSarlaft, sort: true }
        );
        break;
      case TipoOpcion.INFIIN:
      case TipoOpcion.INFIEG:
      case TipoOpcion.INFIAC:
      case TipoOpcion.INFIPT:
      case TipoOpcion.INFIPA:
        columnasXvariable.push(
          { field: 'codigoCondicion', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_CODIGO' ), sort: false },
          { field: 'rangoInicial', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_RANGOINICIAL' ), sort: true },
          { field: 'rangoFinal', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_RANGOFINAL' ), sort: true },
        );
        break;
      case TipoOpcion.PEP:
        columnasXvariable.push(
          { field: 'codigoPep', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_CODIGO' ), sort: false },
          { field: 'pep', header: this.variable.variableSarlaft, sort: true },
          { field: 'valor', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_VALOR'), sort: true }
        );
        break;

      case TipoOpcion.TIPOCU:
        columnasXvariable.push(
          { field: 'codigoTipoOcupacion', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_CODIGO' ), sort: false },
          { field: 'tipoOcupacion', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_OCUPACION' ), sort: true },
        );
      break;
      case TipoOpcion.PRODUC:
        columnasXvariable.push(
          { field: 'codigoProducto', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_CODIGO' ), sort: false },
          { field: 'producto', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_OCUPACION' ), sort: true },
        );
        break;
      case TipoOpcion.OCUPAC:
        columnasXvariable.push(
          { field: 'codigoOcupacion', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_CODIGO' ), sort: false },
          { field: 'ocupacion', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_OCUPACION' ), sort: true },
        );
        break;
      default:
        break;

    }
    this.columnas = this.columnas.concat( columnasXvariable );
    if (this.listaVariablesColumnasFinalesIguales.includes(this.variable.codigoVariableSarlaft)) {
      this.columnas.push(
        { field: 'puntaje', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_PUNTAJE' ), sort: true },
        { field: 'peso', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_PESO' ), sort: true },
        { field: 'ponderacion', header: this.navServicio.buscarMensaje( 'SARLAFT.LBL_PONDERACION' ), sort: true }
      );
    }

    if (!this.verDetalle) {
      this.columnas.push( { field: 'acciones', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false });
    }
  }

  obtenerListaGenerica(opcion: any, Lista: any[]) {
    this.lisgenerica = [];
    const lista = obteneItemSarlaft( opcion, Lista);
    if(lista && lista.length > 0){
      lista.map(c => {
        const item = {value: c.value, label: c.label};
        this.lisgenerica.push(item);
      });
    }
    this.loading = false;
    this.cerrarFondoGlobalModal();
  }

  setNombreGenerico(opcion:any) {
    let nombreDrop = '';
    switch (opcion) {
      case TipoOpcion.VCANAL:
        nombreDrop = this.navServicio.buscarMensaje('SARLAFT.LBL_CANAL');
        return nombreDrop;
      case TipoOpcion.NACION:
        return nombreDrop = this.navServicio.buscarMensaje('SARLAFT.LBL_NACIONALIDAD');
      case TipoOpcion.JURISD:
        return nombreDrop = this.navServicio.buscarMensaje('SARLAFT.LBL_PAISDERESIDENCIA');
      case TipoOpcion.ACTECO:
        return nombreDrop = this.navServicio.buscarMensaje('SARLAFT.LBL_ACTIVIDADECONOMICA');
      case TipoOpcion.TIPOCU:
        return nombreDrop = this.navServicio.buscarMensaje('SARLAFT.LBL_OCUPACIONES');
      case TipoOpcion.PEP:
        return nombreDrop = this.navServicio.buscarMensaje('SARLAFT.LBL_PERSONAEXPUESTAP');
      case TipoOpcion.PRODUC:
        return nombreDrop = this.navServicio.buscarMensaje('SARLAFT.LBL_PRODUCTO');
      case TipoOpcion.OCUPAC:
        return nombreDrop = this.navServicio.buscarMensaje('SARLAFT.LBL_OFICIO');
      default:
        return nombreDrop;
    }
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      id: [null ],
      idKeyPrincipal: [null ],
      idKeyForanea: [null ],
      idLista: [null],
      codigo: [null],
      rangoInicial: [null],
      rangoFinal: [null],
      valor: [ this.variable ? this.variable.valor : null, ],
      puntaje: [  null, [ Validators.required, Validators.maxLength(5) ], ],
      peso: [ this.variable ? this.variable.peso : null, [ Validators.required, Validators.maxLength(5) ], ],
      ponderacion: [null],
      idDivisionPolitica: [null],
    });

    this.validarCamposRequeridosXVariable();

    this.cargaCondiciones = false;
  }

  validarCamposRequeridosXVariable() {
    let requerido = false;
    if (this.listaVariablesCondicionesInformacionFinanciera.includes(this.variable.codigoVariableSarlaft)) {
       requerido = true;
    }
    this.formulario = this.fb.group({
      id: [null ],
      idKeyPrincipal: [null ],
      idKeyForanea: [null ],
      idLista: [null,
        !requerido ? Validators.required : []],
      codigo: [null,
        requerido ? Validators.required : []],
      rangoInicial: [null,
        requerido ? Validators.required : []],
      rangoFinal: [null,
        requerido ? Validators.required : []],
      valor: [ this.variable ? this.variable.valor : null, ],
      puntaje: [  null, [ Validators.required, Validators.maxLength(5) ], ],
      peso: [ this.variable ? this.variable.peso : null, [ Validators.required, Validators.maxLength(5) ], ],
      ponderacion: [null],
      idDivisionPolitica: [ null,
        this.variable.codigoVariableSarlaft === this.tipOpcion.JURISD ? Validators.required : []]
    });
  }

  get f() {
    return this.formulario.controls;
  }

  crear() {
    const formulario = this.formulario.getRawValue();
    if (this.variable.codigoVariableSarlaft === this.tipOpcion.PEP && !formulario.idKeyPrincipal) {
      const seleccion = this.lisgenerica.find(x => x.value === formulario.idLista).label;
      const filtro = this.condicion.filter(item => item.pep === seleccion && item.valor === (formulario.valor ? 'SI': 'NO'));
      if (filtro && filtro.length>0) {
        this.navServicio.setMesage( 0, {
          severity: 'warn', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'SARLAFT.MSG_REGISTRODUPLICADO' )
        } );
        return;
      }
    }
    this.submitted = true;
    if (this.formulario.valid){
      if (this.listaVariablesCondicionesInformacionFinanciera.includes(this.variable.codigoVariableSarlaft) && this.codExiste) {
        return;
      }
      this.cargaCondiciones = true;
      this.guardar();
    }
  }

  async guardar() {
    const objetoCondicion = {} as any;
    objetoCondicion.idRiesgoSarlaftVariable = this.variable.idRiesgoSarlaftVariable;
    const _data = this.formulario.getRawValue();
    switch (this.variable.codigoVariableSarlaft) {
      case TipoOpcion.VCANAL:
        if (_data.idKeyPrincipal) {
          objetoCondicion.id = _data.id;
          objetoCondicion.idRiesgoSarlaftVariableCondicionCanal = _data.idKeyPrincipal;
          objetoCondicion.idCanal = _data.idLista;
          objetoCondicion.puntaje = _data.puntaje;
          objetoCondicion.indicadorHabilitado = true;
        } else {
          objetoCondicion.idCanal = _data.idLista;
          objetoCondicion.puntaje = _data.puntaje;
          objetoCondicion.indicadorHabilitado = true;
        }
        break;
      case TipoOpcion.NACION:
        if (_data.idKeyPrincipal) {
          objetoCondicion.id = _data.id;
          objetoCondicion.idRiesgoSarlaftVariableCondicionDivisionPolitica = _data.idKeyPrincipal;
          objetoCondicion.idDivisionPolitica = _data.idLista;
          objetoCondicion.puntaje = _data.puntaje;
          objetoCondicion.indicadorHabilitado = true;
        } else {
          objetoCondicion.idDivisionPolitica = _data.idLista;
          objetoCondicion.puntaje = _data.puntaje;
          objetoCondicion.indicadorHabilitado = true;
        }
        break;
      case TipoOpcion.ACTECO:
        if (_data.idKeyPrincipal) {
          objetoCondicion.id = _data.id;
          objetoCondicion.idRiesgoSarlaftVariableCondicionActividadEconomica = _data.idKeyPrincipal;
          objetoCondicion.idActividadEconomica = _data.idLista;
          objetoCondicion.puntaje = _data.puntaje;
          objetoCondicion.indicadorHabilitado = true;
        } else {
          objetoCondicion.idActividadEconomica = _data.idLista;
          objetoCondicion.puntaje = _data.puntaje;
          objetoCondicion.indicadorHabilitado = true;
        }
        break;
      case TipoOpcion.PEP:
        if (_data.idKeyPrincipal) {
          objetoCondicion.id = _data.id;
          objetoCondicion.idRiesgoSarlaftVariableCondicionPep = _data.idKeyPrincipal;
          objetoCondicion.idListaPep = _data.idLista;
          objetoCondicion.valor = _data.valor;
          objetoCondicion.puntaje = _data.puntaje;
        } else {
          objetoCondicion.idListaPep = _data.idLista;
          objetoCondicion.valor = _data.valor;
          objetoCondicion.puntaje = _data.puntaje;
        }
        break;
      case TipoOpcion.TIPOCU:
        if (_data.idKeyPrincipal) {
          objetoCondicion.id = _data.id;
          objetoCondicion.idRiesgoSarlaftVariableCondicionTipoOcupacion = _data.idKeyPrincipal;
          objetoCondicion.idTipoOcupacion = _data.idLista;
          objetoCondicion.puntaje = _data.puntaje;
          objetoCondicion.indicadorHabilitado = true;
        } else {
          objetoCondicion.idTipoOcupacion = _data.idLista;
          objetoCondicion.puntaje = _data.puntaje;
          objetoCondicion.indicadorHabilitado = true;
        }
        break;
      case TipoOpcion.INFIIN:
      case TipoOpcion.INFIEG:
      case TipoOpcion.INFIAC:
      case TipoOpcion.INFIPT:
      case TipoOpcion.INFIPA:
        if (_data.idKeyPrincipal) {
          objetoCondicion.id = _data.id;
          objetoCondicion.idRiesgoSarlaftVariableCondicionInformacionFinanciera = _data.idKeyPrincipal;
          objetoCondicion.codigoCondicion = _data.codigo;
          objetoCondicion.rangoInicial = _data.rangoInicial;
          objetoCondicion.rangoFinal = _data.rangoFinal;
          objetoCondicion.puntaje = _data.puntaje;
          objetoCondicion.indicadorHabilitado = true;
        } else {
          objetoCondicion.rangoInicial = _data.rangoInicial;
          objetoCondicion.rangoFinal = _data.rangoFinal;
          objetoCondicion.codigoCondicion = _data.codigo;
          objetoCondicion.puntaje = _data.puntaje;
          objetoCondicion.indicadorHabilitado = true;
        }
        break;
      case TipoOpcion.PRODUC:
        if (_data.idKeyPrincipal) {
          objetoCondicion.id = _data.id;
          objetoCondicion.idRiesgoSarlaftVariableCondicionProducto = _data.idKeyPrincipal;
          objetoCondicion.idProducto = _data.idLista;
          objetoCondicion.puntaje = _data.puntaje;
        } else {
          objetoCondicion.idProducto = _data.idLista;
          objetoCondicion.puntaje = _data.puntaje;
        }
        break;
      case TipoOpcion.OCUPAC:
        if (_data.idKeyPrincipal) {
          objetoCondicion.id = _data.id;
          objetoCondicion.idRiesgoSarlaftVariableCondicionOcupacion = _data.idKeyPrincipal;
          objetoCondicion.idOcupacion = _data.idLista;
          objetoCondicion.puntaje = _data.puntaje;
        } else {
          objetoCondicion.idOcupacion = _data.idLista;
          objetoCondicion.puntaje = _data.puntaje;
        }
        break;
      case TipoOpcion.JURISD:
        if (_data.idKeyPrincipal) {
          objetoCondicion.id = _data.id;
          objetoCondicion.idRiesgoSarlaftVariableCondicionDivisionPolitica = _data.idKeyPrincipal;
          objetoCondicion.idDivisionPolitica = _data.idDivisionPolitica;
          objetoCondicion.puntaje = _data.puntaje;
        } else {
          objetoCondicion.idDivisionPolitica = _data.idDivisionPolitica;
          objetoCondicion.puntaje = _data.puntaje;
        }
        break;
      default:
        break;
    }
   if (this.listaVariablesCondicionesInformacionFinanciera.includes(this.variable.codigoVariableSarlaft)) {
      if (await this.validarRangosGuardar()) {
        this.validarCondicionInformacionFinanciera(objetoCondicion, _data.idKeyPrincipal ? 2 : 1);
      } else {
        this.navServicio.setMesage( 0, {
          severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'SARLAFT.LBL_MSGRANGOS' )
        } );
        this.submitted = false;
        this.cargaCondiciones = false;
      }

   } else {
     if (_data.idKeyPrincipal) {
       await this.sarlaftCondicionesService.actualizarCondicion(objetoCondicion, this.variable.codigoVariableSarlaft).toPromise();
       this.finalizarProceso(2);
     } else {
       await this.sarlaftCondicionesService.crearCondicion(objetoCondicion, this.variable.codigoVariableSarlaft).toPromise();
       this.finalizarProceso(1);
     }

   }

  }

  finalizarProceso (codigo: number) {
    this.submitted = false;
    this.disabledLista = false;
    this.cargaCondiciones = false;
    this.estadoEditar = false;
    this.cargaInicial();
    this.formulario.markAsPristine();
    this.navServicio.setMesage( codigo );
    this.actualizarPaginadoTabla();

  }

  validarCondicionInformacionFinanciera(objetoCondicionVariable: any, banderaMensaje: number) {
    this.sarlaftCondicionesService.validarCondicionFinanciera(objetoCondicionVariable).subscribe(respuesta => {
      if (respuesta) {
        if (respuesta.estado && respuesta.listado) {
          this.guardarCondicionInformacionFinanciera(respuesta.listado, banderaMensaje);
        }
        if (!respuesta.estado && respuesta.listado) {
          this.confirmacionServicio.confirm({
            message: respuesta.mensaje,
            header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
            icon: 'fa fa-question-circle',
            key: 'confirmar-condicionInformacionFinanciera',
            accept: () => {
              this.guardarCondicionInformacionFinanciera(respuesta.listado, banderaMensaje);
            },
            reject: () => {
              this.submitted = false;
              this.cargaCondiciones = false;
            },
          });
        }
      }
    }, error => {
      this.navServicio.setMesage( 3 );
      this.submitted = false;
      this.cargaCondiciones = false;
    });
  }

  guardarCondicionInformacionFinanciera (listaValidada: any, banderaMensaje: number) {
    if (listaValidada.length > 0 ) {
      this.sarlaftCondicionesService.bulkCondicionFinanciera(listaValidada).subscribe(respuesta => {
        this.finalizarProceso(banderaMensaje);
      }, error => {
        this.navServicio.setMesage( 3 );
        this.submitted = false;
        this.cargaCondiciones = false;
      });
    } else {
      this.submitted = false;
      this.cargaCondiciones = false;
    }
  }

  editarCondicion( item: any ) {
    this.estadoEditar = true;
    this.disabledLista = true;
    let buscar: any;
    this.f.id.setValue(item.id);
    this.f.id.updateValueAndValidity();
    this.asignarValoresLista();
    switch ( this.variable.codigoVariableSarlaft) {
      case TipoOpcion.NACION:
        buscar = this.lista.find(x => x.idDivisionPolitica === item.idDivisionPolitica);
        this.lisgenerica.push({label: buscar.descripcionDivisonPolitica, value: buscar.idDivisionPolitica});
        this.f.idLista.setValue(item.idDivisionPolitica);
        this.f.idLista.updateValueAndValidity();
        this.f.puntaje.setValue(item.puntaje);
        this.f.puntaje.updateValueAndValidity();
        this.f.idKeyPrincipal.setValue(item.idRiesgoSarlaftVariableCondicionDivisionPolitica);
        this.f.idKeyPrincipal.updateValueAndValidity();
        this.f.idKeyForanea.setValue(item.idRiesgoSarlaftVariable);
        this.f.idKeyForanea.updateValueAndValidity();
        break;
      case TipoOpcion.VCANAL:
          buscar = this.lista.find(x => x.idCanal === item.idCanal);
          this.lisgenerica.push({label: buscar.nombre, value: buscar.idCanal});
          this.f.idLista.setValue(item.idCanal);
          this.f.idLista.updateValueAndValidity();
          this.f.puntaje.setValue(item.puntaje);
          this.f.puntaje.updateValueAndValidity();
          this.f.idKeyPrincipal.setValue(item.idRiesgoSarlaftVariableCondicionCanal);
          this.f.idKeyPrincipal.updateValueAndValidity();
          this.f.idKeyForanea.setValue(item.idRiesgoSarlaftVariable);
          this.f.idKeyForanea.updateValueAndValidity();
        break;
      case TipoOpcion.ACTECO:
        buscar = this.lista.find(x => x.idActividadEconomica === item.idActividadEconomica);
        this.lisgenerica.push({label: buscar.actividadEconomica, value: buscar.idActividadEconomica});
        this.f.idLista.setValue(item.idActividadEconomica);
        this.f.idLista.updateValueAndValidity();
        this.f.puntaje.setValue(item.puntaje);
        this.f.puntaje.updateValueAndValidity();
        this.f.idKeyPrincipal.setValue(item.idRiesgoSarlaftVariableCondicionActividadEconomica);
        this.f.idKeyPrincipal.updateValueAndValidity();
        this.f.idKeyForanea.setValue(item.idRiesgoSarlaftVariable);
        this.f.idKeyForanea.updateValueAndValidity();
        break;
      case TipoOpcion.PEP:
        this.f.idLista.setValue(item.idListaPep);
        this.f.idLista.updateValueAndValidity();
        this.f.valor.setValue(item.valor === "SI");
        this.f.valor.updateValueAndValidity();
        this.f.puntaje.setValue(item.puntaje);
        this.f.puntaje.updateValueAndValidity();
        this.f.idKeyPrincipal.setValue(item.idRiesgoSarlaftVariableCondicionPep);
        this.f.idKeyPrincipal.updateValueAndValidity();
        this.f.idKeyForanea.setValue(item.idRiesgoSarlaftVariable);
        this.f.idKeyForanea.updateValueAndValidity();
        break;
      case TipoOpcion.TIPOCU:
        buscar = this.lista.find(x => x.idLista === item.idTipoOcupacion);
        this.lisgenerica.push({label: buscar.nombre, value: buscar.idLista});
        this.f.idLista.setValue(item.idTipoOcupacion);
        this.f.idLista.updateValueAndValidity();
        this.f.puntaje.setValue(item.puntaje);
        this.f.puntaje.updateValueAndValidity();
        this.f.idKeyPrincipal.setValue(item.idRiesgoSarlaftVariableCondicionTipoOcupacion);
        this.f.idKeyPrincipal.updateValueAndValidity();
        this.f.idKeyForanea.setValue(item.idRiesgoSarlaftVariable);
        this.f.idKeyForanea.updateValueAndValidity();
        break;
      case TipoOpcion.INFIIN:
      case TipoOpcion.INFIEG:
      case TipoOpcion.INFIAC:
      case TipoOpcion.INFIPT:
      case TipoOpcion.INFIPA:
        this.f.codigo.setValue(item.codigoCondicion);
        this.f.codigo.updateValueAndValidity();
        this.f.rangoInicial.setValue(item.rangoInicial);
        this.f.rangoInicial.updateValueAndValidity();
        this.f.rangoFinal.setValue(item.rangoFinal);
        this.f.rangoFinal.updateValueAndValidity();
        this.f.puntaje.setValue(item.puntaje);
        this.f.puntaje.updateValueAndValidity();
        this.f.idKeyPrincipal.setValue(item.idRiesgoSarlaftVariableCondicionInformacionFinanciera);
        this.f.idKeyPrincipal.updateValueAndValidity();
        this.f.idKeyForanea.setValue(item.idRiesgoSarlaftVariable);
        this.f.idKeyForanea.updateValueAndValidity();
        break;
      case TipoOpcion.PRODUC:
        buscar = this.lista.find(x => x.idProducto === item.idProducto);
        this.lisgenerica.push({label: buscar.nombre, value: buscar.idProducto});
        this.f.idLista.setValue(item.idProducto);
        this.f.idLista.updateValueAndValidity();
        this.f.puntaje.setValue(item.puntaje);
        this.f.puntaje.updateValueAndValidity();
        this.f.idKeyPrincipal.setValue(item.idRiesgoSarlaftVariableCondicionProducto);
        this.f.idKeyPrincipal.updateValueAndValidity();
        this.f.idKeyForanea.setValue(item.idRiesgoSarlaftVariable);
        this.f.idKeyForanea.updateValueAndValidity();
        break;
      case TipoOpcion.OCUPAC:
        buscar = this.lista.find(x => x.idOcupacion === item.idOcupacion);
        this.lisgenerica.push({label: buscar.ocupacion, value: buscar.idOcupacion});
        this.f.idLista.setValue(item.idOcupacion);
        this.f.idLista.updateValueAndValidity();
        this.f.puntaje.setValue(item.puntaje);
        this.f.puntaje.updateValueAndValidity();
        this.f.idKeyPrincipal.setValue(item.idRiesgoSarlaftVariableCondicionOcupacion);
        this.f.idKeyPrincipal.updateValueAndValidity();
        this.f.idKeyForanea.setValue(item.idRiesgoSarlaftVariable);
        this.f.idKeyForanea.updateValueAndValidity();
        break;
      case TipoOpcion.JURISD:
        this.f.idLista.setValue(item.idDivisionPoliticaPadre);
        this.f.idLista.updateValueAndValidity();
        this.asignarLista(item.idDivisionPolitica);
        this.f.puntaje.setValue(item.puntaje);
        this.f.puntaje.updateValueAndValidity();
        this.f.idKeyPrincipal.setValue(item.idRiesgoSarlaftVariableCondicionDivisionPolitica);
        this.f.idKeyPrincipal.updateValueAndValidity();
        this.f.idKeyForanea.setValue(item.idRiesgoSarlaftVariable);
        this.f.idKeyForanea.updateValueAndValidity();
        break;
      default:
        break;
    }
  }

  setBusqueda() {
    this.navServicio.setSearch( 'sarlaftCondiciones.component', this.busqueda );
  }

  onUpload(event: any) {
    this.respuesta = event.originalEvent.body;
    if (this.respuesta) {
      if(this.respuesta.estado){
        this.modal = {width: '400px'};
        this.estado = 'bien';
        if(this.respuesta.mensajes.length>0){
          this.respuesta.mensajes.map(mensaje => {
            this.mensajes.push(mensaje.replaceAll("\n", "<br>"));
          });
        }
      }else{
        this.eliminarAdjunto();
        this.modal = {width: '550px'};
        this.estado = 'mal';
        if(this.respuesta.mensajes.length>0){
          this.respuesta.mensajes.map(mensaje => {
            this.mensajes.push(mensaje);
          });
        }
      }
    } else {
      this.navServicio.setMesage( 0, {
        severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'FABRICACREDITO.LBL_HAOCURRIDOERROR' )
      } );
      this.modalAbierto = false;
      this.eliminarAdjunto();
    }
  }

  onSelect( event: any, file: any ) {
    this.mensajes = [];
    this.estado = 'car';
    this.modal = {width: '400px'};
    this.modalAbierto = true;
    this.nombreArchivo = file[ 0 ].name;
  }

  onBeforeSend(event: any) {
    this.adjService.cargarArchivo( event, this.nombreArchivo, 'Desprendible de pago' );
  }

  eliminarAdjunto() {
    this.nombreArchivo = null;
  }

  cerrarModal(){
    this.modalAbierto = false;
    this.cerrarFondoGlobalModal();
  }

  cerrarFondoGlobalModal() {
    setTimeout(() => {
      const masks = document.querySelectorAll('.p-dialog-mask-scrollblocker');
      masks.forEach(m => m.remove());
    }, 50);
  }

  cerrarModalExito(guardar: boolean){
    if (guardar) {
      this.loading = true;
      this.sarlaftCondicionesService.guardarRegistrosAdjunto(this.respuesta, this.variable.idRiesgoSarlaftVariable).subscribe( res => {
        if (res) {
          const today = new Date();
          const yyyy = today.getFullYear();
          let mm: any = today.getMonth() + 1;
          let dd: any = today.getDate();
          let hr: any = today.getHours();
          let mn: any = today.getMinutes();
          let sc: any = today.getSeconds();
          if (dd < 10) dd = '0' + dd;
          if (mm < 10) mm = '0' + mm;
          if (hr < 10) hr = '0' + hr;
          if (mn < 10) mn = '0' + mn;
          if (sc < 10) sc = '0' + sc;
          const hora = hr +':'+mn +':'+sc;
          this.fechaCargueArchivo = yyyy + '-' + mm + '-' + dd + 'T'+ hora;
          this.nombreCargueArchivo = this.respuesta.adjuntoCargue.nombreArchivo;
          this.nombreArchivo = '';
          this.cargaInicial();
          this.navServicio.setMesage( 0, {
            severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'INSUMOPECUARIO.MSG_REGGUAR' )
          } );
        } else {
          this.loading = false;
          this.cerrarFondoGlobalModal();
          this.navServicio.setMesage( 0, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'FABRICACREDITO.LBL_HAOCURRIDOERROR' )
          } );
          this.modalAbierto = false;
        }
      })
      this.modalAbierto = false;
    } else {
      this.confirmacionServicio.confirm( {
        message: this.navServicio.buscarMensaje(
          'SARLAFT.MSG_CERRARMODAL'
        ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        key: 'confirmacion-adjunto',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.modalAbierto = false;
          this.eliminarAdjunto()
        }, reject: () => {}
      } );
    }
  }
  buscarValorEnEnum(valor: string): TipoOpcion | undefined {
    const enumKeys = Object.keys(TipoOpcion);

    for (const key of enumKeys) {
      if (TipoOpcion[key] === valor) {
        return TipoOpcion[key] as TipoOpcion;
      }
    }

    return undefined;
  }

  inhabilitarCondicion( row: any ) {
    this.submitted = true;
    this.confirmacionServicio.confirm({
      message: this.navServicio.buscarMensaje(
        'PRODUCTOCONCEPTO.MSG_CONFGUARDADOELIMINAR'
      ),
      header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      key: 'confirmar-guardado',
      accept: () => {
        this.cargaCondiciones = true;
        this.deshabilitarRegistro(row);
      },
      reject: () => {
        this.submitted = false;
        this.cargaCondiciones = false;
      },
    });

  }

 async deshabilitarRegistro (_dataInhabilitar: any) {
    _dataInhabilitar.indicadorHabilitado = false;
   if (this.variable.codigoVariableSarlaft === this.tipOpcion.PEP) {
     _dataInhabilitar.valor = _dataInhabilitar.valor === "SI";
   }
    if (this.listaVariablesCondicionesInformacionFinanciera.includes(this.variable.codigoVariableSarlaft)) {
      this.validarCondicionInformacionFinanciera(_dataInhabilitar, 2);
    } else {
      await this.sarlaftCondicionesService.actualizarCondicion(_dataInhabilitar, this.variable.codigoVariableSarlaft).toPromise();
      this.finalizarProceso(2);
    }

  }
 async asignarLista(idDivisionPolitica?: any) {
    let listaTemporal = [];
    this.listaDepartamentos = [];
    switch (this.variable.codigoVariableSarlaft) {
      case TipoOpcion.JURISD:
        listaTemporal = await this.divisionPoliticaService.obtenerHijosHabilitados( this.f.idLista.value ).toPromise();
        listaTemporal.forEach(x => {
          const existeItem = this.condicion.find(l => l.idDivisionPolitica === x.idDivisionPolitica );
          if (!existeItem) {
            this.listaDepartamentos.push({label: x.descripcionDivisonPolitica, value: x.idDivisionPolitica});
          }
          if (existeItem && x.idDivisionPolitica === idDivisionPolitica) {
            this.listaDepartamentos.push({label: x.descripcionDivisonPolitica, value: x.idDivisionPolitica});
          }
        });
        if (idDivisionPolitica) {
          this.f.idDivisionPolitica.setValue(idDivisionPolitica);
          this.f.idDivisionPolitica.updateValueAndValidity();
        }
        this.segundoInputHabilitado = true;
        break;
      default:
        break;
    }

  }

  validarCodigo() {
    this.codExiste = !!this.condicion.find(x => x.codigoCondicion === this.f.codigo.value);
  }

  validarRangos( event: any, desde: boolean ) {
    const rangoDesde = this.f.rangoInicial.value;
    const rangoHasta = this.f.rangoFinal.value;
    if ( desde && rangoHasta ) {
      if ( Number( rangoDesde ) >= Number( rangoHasta ) ) {
        this.rangoIncialValido = false;
      } else {
        this.rangoIncialValido = true;
      }
    } else if ( !desde && rangoDesde ) {
      if ( Number( rangoDesde ) >= Number( rangoHasta ) ) {
        this.rangoIncialValido = false;
      } else {
        this.rangoIncialValido = true;
      }
    }
  }

 async validarRangosGuardar() {
    const rangoDesde = this.f.rangoInicial.value;
    const rangoHasta = this.f.rangoFinal.value;
   if (!isNaN(rangoDesde) && !isNaN(rangoHasta)) {
     this.rangoIncialValido = rangoDesde < rangoHasta;
     return this.rangoIncialValido;
   } else {
     this.rangoIncialValido = false;
     return false;
   }
  }

  actualizarVariable(variable: Variable) {
    this.variable = variable;
    this.cargaInicial();
  }

  actualizarPaginadoTabla() {
    const pagina = this.tabla.first > 0 ? ( this.tabla.first / 10 ) + 1 : 1;
    setTimeout( () => {
      const canPagina = this.tabla.totalRecords > 0 ? ( Math.floor( ( this.tabla.totalRecords - 1 ) / 10 ) ) + 1 : 1;
      if ( pagina > canPagina ) {
        this.tabla.first = pagina > 1 ? ( pagina - 2 ) * 10 : 0;
      }
    }, 5 );
  }

  limpiarBuscador() {
    this.busqueda = '';
    this.navServicio.setSearch( 'sarlaftCondiciones.component', this.busqueda );
  }
}
